define('views/parts/view-toggle',[
    // Libs
    'underscore', 'backbone', 'mustache', 'utils',
    // views
    'views/parts/form/choices'
], function(
    // Libs
    _, Backbone, Mustache, U,
    // views
    VChoices
) {
    var VViewToggle = Backbone.View.extend({
        template: '<div class="toggle"></div>',

        regions: {
            checkbox: ".toggle",
        },

        initialize: function(options) {
           _.extend(this, options);

           this.model = new Backbone.Model({ show: false });

           this.checkbox = new VChoices({
               label: this.label || '',
               help: this.help || '',
               model: this.model,
               attribute: 'show'
           });

           this.listenTo(this.model, 'change', this.onModelChange);
        },

        render: function() {
            this.$el.empty().append(Mustache.render(this.template, Mustache.getContext()));

            this.generateZones();
            this.assign(this.checkbox, this.zone.$checkbox);

            this.hideView();
            return this;
        },

        hideView: function() {
            // We need to hide the view by default
            this.model.set('show', false);
            this.view.$el.hide();
        },

        onModelChange: function() {
            this.view.$el.slideToggle();
        },
    });

    return VViewToggle;
});

